import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteDocument } from 'api/documents';
import Button from 'components/Button';
import Popup from 'components/Popup';

export default function DocumentPopupRemove({
    visible,
    setVisible,
    document
}) {

    const cache = useQueryClient();

    const { mutate: remove, status } = useMutation({
        mutationKey: ['deleteDocument'],
        mutationFn: deleteDocument,
        onSuccess: () => {
            cache.invalidateQueries(['documents']);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error removing document:", error);
        }
    });

    function onConfirmHandler() {
        return remove({
            id: document._id,
        });
    }

    if(!visible) return null;

    return (
        <Popup  
            visible={visible}
            setVisible={setVisible}
        >
            <div>
                <div className='flex'>
                    <p className=''>Sei sicuro di voler eliminare questo documente? Questa azione non può essere annullata.</p>
                </div>

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='text-grey hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button onClick={onConfirmHandler} status={status}>Elimina</Button>
                </div>
            </div>
        </Popup>
    )
}
